import ClearAllIcon from "@mui/icons-material/ClearAll";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import GetAppIcon from "@mui/icons-material/GetApp";
import { Button, ButtonGroup } from "@mui/material";

interface Props {
	deleteItem?: () => void;
	editItem?: () => void;
	editAllItems?: () => void;
	downloadItem?: () => void;
	deleteLabel?: string;
	editLabel?: string;
	editAllLabel?: string;
	downloadLabel?: string;
}

export const AgGridHeaderButtons = ({
	deleteItem,
	editItem,
	editAllItems,
	downloadItem,
	downloadLabel,
	deleteLabel,
	editLabel,
	editAllLabel,
}: Props) => {
	return (
		<>
			<ButtonGroup>
				{editItem && (
					<Button
						color={"primary"}
						onClick={() => {
							editItem();
						}}
						title={editLabel || "Edit"}
						style={{
							padding: "2px",
						}}
					>
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{editAllItems && (
					<Button
						color={"primary"}
						variant="outlined"
						onClick={() => {
							editAllItems();
						}}
						title={editAllLabel || "Edit All"}
						style={{
							padding: "2px",
						}}
					>
						<ClearAllIcon style={{ cursor: "pointer" }} fontSize="small" />
						<EditIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{deleteItem && (
					<Button
						color={"error"}
						onClick={() => {
							deleteItem();
						}}
						title={deleteLabel || "Delete"}
						style={{
							padding: "2px",
						}}
					>
						<DeleteIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
				{downloadItem && (
					<Button
						color={"primary"}
						onClick={() => {
							downloadItem();
						}}
						title={downloadLabel || "Get data"}
						style={{
							padding: "2px",
						}}
					>
						<GetAppIcon style={{ cursor: "pointer" }} fontSize="small" />
					</Button>
				)}
			</ButtonGroup>
		</>
	);
};
